// extracted by mini-css-extract-plugin
export default {"CreateSurveyRecordVerification":"CreateSurveyRecordVerification_CreateSurveyRecordVerification__Swmcl"};